// src/config.js
let ENV = null;

export async function loadConfig() {
    const origin = window.location.origin;
    const candidates = [
        `${origin}/config.json`,           // preferred
        `${origin}/runtime-config.json`,   // optional fallback
    ];

    let lastErr;
    for (const url of candidates) {
        try {
            const resp = await fetch(`${url}?ts=${Date.now()}`, {
                cache: "no-store",
                headers: { Accept: "application/json, text/plain, */*" },
            });
            if (!resp.ok) throw new Error(`HTTP ${resp.status} for ${url}`);

            const raw = await resp.text();
            if (/^\s*<!doctype\s+html|^\s*<html[\s>]/i.test(raw)) {
                throw new Error(`Got HTML instead of JSON from ${url} (SPA rewrite or missing artifact).`);
            }

            let parsed;
            try { parsed = JSON.parse(raw); }
            catch (e) { throw new Error(`Invalid JSON at ${url}: ${e.message}`); }

            ENV = Object.freeze(parsed || {});
            window.__APP_CONFIG__ = ENV;
            return ENV;
        } catch (e) {
            lastErr = e;
            // try next candidate
        }
    }
    throw new Error(`${lastErr?.message || "Failed to load config."} Ensure /config.json is deployed at the site root and excluded from SPA rewrites.`);
}

export function getConfig() {
    if (!window.__APP_CONFIG__) throw new Error("Config not loaded");
    return window.__APP_CONFIG__;
}
